import { render, staticRenderFns } from "./JobSideMenu.vue?vue&type=template&id=2b50d543&scoped=true&"
import script from "./JobSideMenu.vue?vue&type=script&lang=js&"
export * from "./JobSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./JobSideMenu.vue?vue&type=style&index=0&id=2b50d543&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b50d543",
  null
  
)

export default component.exports